export const INTROBILD = 'Introbild'
export const SMALL_COMPANY = 'Kleinbetrieb'
export const MIDDLE_COMPANY = 'Mittelstand'
export const LARGE_COMPANY = 'Großindustrie'
export const BRANCH_CAMERAS = 'K'
export const BRANCH_SUPPLIER = 'Z'
export const BRANCH_CHEMICALS = 'P'
export const BRANCH_INSTITUTIONS = 'I'

export const INTRO_GROUPS = [
  'Außenansicht heute',
  'Außenansicht historisch',
  'Bildmarke',
  'Innenansicht',
  'Introbild',
  'Kartenmaterial historisch',
  'Katalog - Preisliste',
  'Marke der Firma',
  'Nachweis ABD',
  'Periodikum',
  'Person',
  'Produkt',
  'Prospekt',
  'Textmarke',
  'Werbeanzeige',
]
